export abstract class ApiConstants {
  static readonly questionApiBaseUrl = `${window.postbuildEnv.DEFAULT_URL}/api/v1/questions`;
};
